export default {
  title: "Groups",
};
